import type { SemanticCOLORS } from 'semantic-ui-react';

export const SEMANTIC_COLORS: SemanticCOLORS[] = [
  'black',
  'blue',
  'brown',
  'green',
  'grey',
  'olive',
  'orange',
  'pink',
  'purple',
  'red',
  'teal',
  'violet',
  'yellow',
];
